import { useMemo } from 'react'
import { Column } from 'react-table'
import { DraggableTable, OnReorder, RANK } from 'components/DraggableTable'
import { useContent } from 'lib/content/react'
import { Merchant } from 'types/entities'

export type MerchantListReorderProps = {
  merchants: Merchant[]
  onReorder: OnReorder
}

export const MerchantListReorder = ({
  merchants,
  onReorder,
}: MerchantListReorderProps) => {
  const { formatMessage } = useContent()
  const columns = useMemo<Column<Merchant>[]>(
    () => [
      {
        Header: formatMessage({
          id: 'pmportal.restaurantLists.positionOnList',
        }),
        columns: [
          {
            accessor: 'position',
            id: RANK,
          },
          {
            id: 'drag-handle',
          },
          {
            accessor: 'name',
          },
        ],
      },
      {
        Header: formatMessage({ id: 'pmportal.restaurantLists.address' }),
        columns: [
          {
            accessor: 'address',
          },
        ],
      },
      {
        Header: formatMessage({ id: 'pmportal.restaurantLists.inNetwork' }),
        columns: [
          {
            accessor: 'inMerchantNetwork',
            Cell: ({ value }) =>
              formatMessage({ id: `pmportal.global.${value ? 'yes' : 'no'}` }),
          },
        ],
      },
    ],
    [formatMessage]
  )

  return (
    <DraggableTable
      showHeader
      columns={columns}
      data={merchants}
      onReorder={onReorder}
      dragHandleId="drag-handle"
    />
  )
}
